var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbolDpdRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1276_9361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 42,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1276_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9692 9.09355L34.4725 9.4063C30.8687 11.5076 27.2746 13.6186 23.6611 15.7101C23.232 15.9039 22.9791 16.3558 23.0377 16.8243C23.1059 18.0753 23.0377 17.9189 24.0701 18.5639C24.4365 18.8513 24.9473 18.8632 25.3266 18.5932C28.6382 16.6386 31.9693 14.6839 35.2809 12.7292L35.8848 12.3872C35.8921 12.5239 35.8921 12.6609 35.8848 12.7976V30.6926C35.8977 31.2999 35.5546 31.8583 35.0082 32.1195L23.8072 38.7752C22.1806 39.7525 20.5442 40.7298 18.9371 41.7072C18.3674 42.0976 17.6173 42.0976 17.0476 41.7072C11.6906 38.5015 6.33357 35.3219 0.976561 32.1684C0.34683 31.8481 -0.0351456 31.185 0.00255598 30.4776C0.00255598 24.6136 0.00255598 18.7789 0.00255598 12.9736C0.00255598 12.7976 0.00255598 12.6315 0.00255598 12.3872L0.538257 12.6804L15.7814 21.5741C16.1285 21.7256 16.3375 22.0857 16.2976 22.4635C16.2976 26.8028 16.2976 31.1324 16.2976 35.4718V35.9116C16.2849 36.2013 16.446 36.4706 16.7067 36.5957L17.5248 37.0551C17.7823 37.2115 18.105 37.2115 18.3625 37.0551L19.1417 36.625C19.4224 36.5043 19.595 36.2171 19.5702 35.9116C19.5702 35.7943 19.5702 35.677 19.5702 35.5598V20.8216C19.5702 20.6847 19.5702 20.5577 19.5702 20.4209C19.5796 20.1526 19.436 19.9024 19.2001 19.7758L17.9631 19.0526L1.48304 9.4063L0.976561 9.10333L1.38564 8.8199L16.9697 0.278003C17.5665 -0.0926677 18.3209 -0.0926677 18.9177 0.278003C24.1286 3.15136 29.32 5.97586 34.5114 8.8199L34.9692 9.09355Z",
    fill: "#DC0032"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDpdRed);
export default __webpack_public_path__ + "static/media/symbolDpdRed.670dce30f63fd583fdde2a89a62fa7ab.svg";
export { ForwardRef as ReactComponent };